<h-icon-button
    [attr.id]="filterTag().id"
    [border]="false"
    [borderRadius]="false"
    [gapBetweenSvgAndText]="4"
    [lineHeight]="'0'"
    [backgroundColor]="SECONDARY_EXTRA_LIGHT"
    (pressed)="remove.emit(filterTag())"
    [appearance]="'SVG_WITH_TEXT_RIGHT'">
    <div text class="text">
        <ng-container *ngTemplateOutlet="priceRangeTemplate"></ng-container>
        <ng-container *ngTemplateOutlet="filterTemplate"></ng-container>
    </div>
    <div class="icon"> <h-svg-icon [name]="'cross'" class="icon-delete"></h-svg-icon></div>
    <ng-template #priceRangeTemplate>
        @if (priceRange()) {
        <div>
            <span>{{ valueMinCurrent() | hCurrency : "short" }}</span>
            <span>&nbsp;-&nbsp;</span>
            <span>{{ valueMaxCurrent() | hCurrency : "short" }}</span>
        </div>
        }
    </ng-template>
    <ng-template #filterTemplate>
        @if (!priceRange()) {
        <div>
            {{ filterTag().filter.name }}
        </div>
        }
    </ng-template>
</h-icon-button>
